export default "__VITE_ASSET__ycxBZ9Vy__"